var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsaGlisanta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "af170d81-4072-4529-b43d-187e63a286c9",
    "data-name": "glisanta_ridicare",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.5 177.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a0bc4ee7-d36e-4a2f-a6e5-d0d747c69c6a,.bb30e4c1-62e4-47be-97e4-00e681fb489f,.ec995af3-e5e9-47fc-adb8-75c5d869ae8e,.fb5e9a38-1331-41f1-90ca-f9a5d23552f2,.fd3292a0-17e5-4521-b8b1-0e039ff902d7{fill:none;stroke-linecap:round;stroke-linejoin:round;}.a0bc4ee7-d36e-4a2f-a6e5-d0d747c69c6a,.ec995af3-e5e9-47fc-adb8-75c5d869ae8e,.fb5e9a38-1331-41f1-90ca-f9a5d23552f2,.fd3292a0-17e5-4521-b8b1-0e039ff902d7{stroke:#000;}.a0bc4ee7-d36e-4a2f-a6e5-d0d747c69c6a{stroke-width:10px;}.ec995af3-e5e9-47fc-adb8-75c5d869ae8e{stroke-width:8px;}.fd3292a0-17e5-4521-b8b1-0e039ff902d7{stroke-width:5px;}.bb30e4c1-62e4-47be-97e4-00e681fb489f,.fb5e9a38-1331-41f1-90ca-f9a5d23552f2{stroke-width:3px;}.bb30e4c1-62e4-47be-97e4-00e681fb489f{stroke:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "usa_glisanta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f0f59342-f4b0-4430-b8c6-34ef85ef6d28",
    "data-name": "fereastra copy 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bd412f84-4c1b-45d8-9e60-ca557b8e61fb",
    "data-name": "usa glisanta"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "a0bc4ee7-d36e-4a2f-a6e5-d0d747c69c6a",
    points: "126.56 5 55 5 55 147.12 178 147.12 178 22.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec995af3-e5e9-47fc-adb8-75c5d869ae8e",
    d: "M84.66,126.66",
    transform: "translate(-3.5 -17.94)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ec995af3-e5e9-47fc-adb8-75c5d869ae8e",
    points: "81.16 106.06 81.16 126.06 151.84 126.06 151.84 26.06 81.16 26.06 81.16 78.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a0bc4ee7-d36e-4a2f-a6e5-d0d747c69c6a",
    points: "55 5 178 5 178 147.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "fd3292a0-17e5-4521-b8b1-0e039ff902d7",
    x1: 67.42,
    y1: 75.94,
    x2: 97,
    y2: 110.56
  })), /*#__PURE__*/React.createElement("line", {
    className: "a0bc4ee7-d36e-4a2f-a6e5-d0d747c69c6a",
    x1: 7.5,
    y1: 172.06,
    x2: 187.5,
    y2: 172.06
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fb5e9a38-1331-41f1-90ca-f9a5d23552f2",
    d: "M6.75,171.57a19.12,19.12,0,0,1,1.43-9.24,5.9,5.9,0,0,0,2.48,2.42,33.17,33.17,0,0,1-.65-6.59,58.68,58.68,0,0,1,16-15.85,9.89,9.89,0,0,0,1.4,4.15,17.07,17.07,0,0,1,1.52-6c13.07-7.21,24.21.73,8.8,12.5-3,2.55-3.67,3.44-7.13,7.79-1.85.13-2.43-.25-5.71,0A7.84,7.84,0,0,0,29,163.16c-3.93,5.09-9.64,12.88-17.85,13.31",
    transform: "translate(-3.5 -17.94)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fb5e9a38-1331-41f1-90ca-f9a5d23552f2",
    d: "M5,182.51a83.69,83.69,0,0,1,33-39.68",
    transform: "translate(-3.5 -17.94)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bb30e4c1-62e4-47be-97e4-00e681fb489f",
    d: "M100.5,184.5,90,191.41",
    transform: "translate(-3.5 -17.94)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bb30e4c1-62e4-47be-97e4-00e681fb489f",
    d: "M115.5,184.5,105,191.41",
    transform: "translate(-3.5 -17.94)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bb30e4c1-62e4-47be-97e4-00e681fb489f",
    d: "M130.5,184.5,120,191.41",
    transform: "translate(-3.5 -17.94)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fb5e9a38-1331-41f1-90ca-f9a5d23552f2",
    d: "M101.5,184.41,90,177.5",
    transform: "translate(-3.5 -17.94)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fb5e9a38-1331-41f1-90ca-f9a5d23552f2",
    d: "M116.5,184.41,105,177.5",
    transform: "translate(-3.5 -17.94)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "fb5e9a38-1331-41f1-90ca-f9a5d23552f2",
    d: "M131.5,184.41,120,177.5",
    transform: "translate(-3.5 -17.94)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaGlisanta);
export default __webpack_public_path__ + "static/media/usa_glisanta.d0e7a03eb8d2ce6fb1929966581804b2.svg";
export { ForwardRef as ReactComponent };